(() => {
  const mediaQuery = window.matchMedia('(min-width: 990px)');

  function bindGalleryScrollChain() {
    if (!document.body.classList.contains('cb-product-context')) return;

    const gallery = document.querySelector('.product__media-wrapper');
    if (!gallery || gallery.dataset.scrollChainBound === 'true') return;

    gallery.dataset.scrollChainBound = 'true';

    gallery.addEventListener(
      'wheel',
      (event) => {
        if (!mediaQuery.matches) return;

        const maxScroll = gallery.scrollHeight - gallery.clientHeight;
        if (maxScroll <= 1) return;

        const atTop = gallery.scrollTop <= 0;
        const atBottom = gallery.scrollTop >= maxScroll - 1;
        const scrollingUp = event.deltaY < 0;
        const scrollingDown = event.deltaY > 0;

        if ((scrollingDown && atBottom) || (scrollingUp && atTop)) {
          event.preventDefault();
          window.scrollBy({
            top: event.deltaY,
            left: 0,
            behavior: 'auto',
          });
        }
      },
      { passive: false },
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGalleryScrollChain);
  } else {
    bindGalleryScrollChain();
  }
})();
